"use client";
import React from "react";
import { Contest, Team } from "@/sources/kicker-amateur/types";
import { TabBarTabButton } from "@/app/pwa/components/TabBar";
import { TeamName } from "../../components/team/TeamName";
import Button from "../../components/Button";
import ChevronRight from "@/assets/icon/chevron-right.svg";
import ChevronLeft from "@/assets/icon/chevron-left.svg";
import { DropdownSelect } from "../../components/DropdownSelect";
import { SingleValue } from "react-select";
import { useUpdateQueryParams } from "@/hooks/useUpdateQueryParams";
import { BaseTeamContestTableProps, TeamContestTableImp } from "../../components/team/TeamContestTable";
import NoContent from "../../components/NoContent";

type ClubTableProps = BaseTeamContestTableProps & {
  clubTeams: any[];
  contests: Contest[]
};

export function ClubTable(props: ClubTableProps) {
  const { teamId, clubTeams, contests } = props;
  const teamIndex = clubTeams.findIndex((c) => c.Id === teamId);
  const contestId = contests ? contests[0]?.Id : undefined

  const { updateQueryParam } = useUpdateQueryParams();

  const handleTeamIdChange = (value: number) => {
    updateQueryParam('teamId', value.toString())
  };

  return (
    <div>
      <div className="grid justify-between grid-cols-[auto_1fr] @md:grid-cols-[1fr_auto_1fr] border-b border-gray-150 py-1">
        {clubTeams.length > 1 ? (
          <>
            <div className="">
              <h3 className="text-lg font-bold text-left px-4 pt-2 pb-1.5">
                Tabelle
              </h3>
            </div>
            <div className="flex items-center min-w-0 justify-self-end @md:justify-self-center">
              <Button
                className="shrink-0"
                color="link-muted"
                disabled={clubTeams[teamIndex - 1] === undefined}
                onClick={() =>
                  clubTeams[teamIndex - 1] && handleTeamIdChange(clubTeams[teamIndex - 1].Id)
                }
                aria-label="Vorheriges Team"
              >
                <ChevronLeft />
              </Button>
              <DropdownSelect
                id="team-select-club-table"
                className="z-20 min-w-0 w-36 team-tag-select"
                aria-label="Team auswählen"

                options={clubTeams}
                isClearable={false}
                isSearchable={false}
                isMulti={false}
                value={clubTeams.find((team) => team.Id === teamId)}
                isOptionSelected={(option) => option.Id === teamId}
                formatOptionLabel={(data) => {
                  return <span className="text-sm"><TeamName team={data} teamTypeName /></span>;
                }}
                onChange={(selectedOption: SingleValue<Team>) => {
                  handleTeamIdChange(selectedOption?.Id!);
                }}
              />
              <Button
                className="shrink-0"
                color="link-muted"
                disabled={clubTeams[teamIndex + 1] === undefined}
                onClick={() =>
                  clubTeams[teamIndex + 1] && handleTeamIdChange(clubTeams[teamIndex + 1].Id)
                }
                aria-label="Nächstes Team"
              >
                <ChevronRight />
              </Button>
            </div>
            {/* <div className="flex-grow hidden @md:block w-auto"></div> */}
          </>
        ) : (
          <h2 className="text-lg font-semibold flex-grow text-center px-4 pb-1.5 w-0">
            Tabelle
          </h2>
        )}
        {false && (
          <div className="w-full flex justify-center min-w-0">
            <div className="tab-bar">
              {clubTeams.map((team) => (
                <TabBarTabButton
                  key={`TabBarTabButton-${team.Id}`}
                  onClick={() => handleTeamIdChange(team.Id)}
                  isActive={teamId === team.Id}
                  className="tab-bar__tab"
                >
                  <TeamName team={team} teamId={team.Id} teamTypeName />
                </TabBarTabButton>
              ))}
            </div>
          </div>
        )}
      </div>
      <div className="border-2 border-transparent mt-3">
        {contestId ? (
          <TeamContestTableImp
            {...props}
            contestId={contestId}
            teamId={teamId}
          />
        ) : <NoContent>Keine Tabelle verfügbar</NoContent>}
      </div>
    </div>
  );
}
